<template>
    <section>
        <b-modal :active.sync="isActive" has-modal-card @close="close">
            <div class="modal-card" style="">
                <header class="modal-card-head">
                    <p class="modal-card-title">Edit {{project.name}}</p>
                </header>
                <section class="modal-card-body">
                    <b-tabs v-model="selectedTabIndex">
                        <b-tab-item label="Details">
                            <b-field label="Name">
                                <b-input v-model="editProject.name"></b-input>
                            </b-field>

                            <b-field label="Pitch">
                                <b-input type="textarea" v-model="editProject.pitch"></b-input>
                            </b-field>

                            <b-field label="Description">
                                <b-input type="textarea" v-model="editProject.description" maxlength="500"></b-input>
                            </b-field>
                        </b-tab-item>
                        <b-tab-item label="Logo">
                            <cropper
                                context="projectLogo"
                                :width="540"
                                :height="410"
                                @uploadSuccess="uploadSuccess"
                                @uploadFailure="uploadFailure"
                            />
                        </b-tab-item>
                        <b-tab-item label="Body">
                            <b-field>
                                <vue-editor id="editor-md" v-model="editProject.body" :editorToolbar="customToolbar"></vue-editor>
                            </b-field>
                        </b-tab-item>
                    </b-tabs>
                </section>
                <footer class="modal-card-foot">
                    <button class="button" type="button" @click="close">Close</button>
                    <button class="button is-success" @click="save">Save</button>
                </footer>
            </div>
        </b-modal>
    </section>
</template>

<script>
    export default {
        name: 'EditProjectModal',
        props: ['project', 'isActive', 'selectedTabIndex'],
        data() {
            return {
                editProject: {
                    name: '',
                    pitch: '',
                    description: '',
                    image: '',
                    body: ''
                },
                customToolbar: [
                    [{ 'header': [1, 2, 3, false] }],

                    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                    ['blockquote'],

                    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                    [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
                    // [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent

                    // [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                    // [{ 'font': [] }],
                    // [{ 'align': [] }],

                    ['clean']                                         // remove formatting button
                ]
            }
        },
        methods: {
            loadDataFromProject: function(project) {
                this.editProject.name = project.name;
                this.editProject.pitch = project.pitch;
                this.editProject.description = project.description;
                this.editProject.image = project.image;
                this.editProject.body = project.body;
            },
            close: function() {
                this.$parent.editProjectModal.isActive = false;
            },
            sendEditProjectRequest: function(body) {
                this.$http.post(this.$hostname + '/project/' + this.$props.project.id + '/edit/general', body).then(function(response) {
                    this.$toast.open({
                      message: 'Updated the project!',
                      type: 'is-success',
                      queue: false
                    })

                    this.$emit('projectUpdated', response.body); // response contains the updated Project record
                    this.loadDataFromProject(response.body); // update this component's data
                }, function(error) {
                    this.$toast.open({
                      message: 'Could not save project. Please try again!',
                      type: 'is-error',
                      queue: false
                    })
                });
            },
            save: function() {
                var data = {};

                if(this.editProject.name) data.name = this.editProject.name;
                if(this.editProject.pitch) data.pitch = this.editProject.pitch;
                if(this.editProject.description) data.description = this.editProject.description;
                if(this.editProject.body) data.body = this.editProject.body;

                this.sendEditProjectRequest(data);
            },
            uploadSuccess: function(imageRecord) {
                this.sendEditProjectRequest({ image: imageRecord.uuid });
            },
            uploadFailure: function(error) {
                this.$toast.open({
                  message: 'Could not upload image. Please try again!',
                  type: 'is-error',
                  queue: false
                })
            },
        },
        computed: {
            isModalActive() {
                return this.$props.isActive;
            }
        },
        mounted: function() {
            this.loadDataFromProject(this.$props.project);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/EditProjectModal.vue